// extracted by mini-css-extract-plugin
export var externalLink = "_94-0";
export var internalLinkLabel = "_94-1";